import React from 'react'
import Logo from '../../../assets/logo.png'
import { styled, Box } from '@mui/material'
import { any } from 'prop-types'
import theme from '../../../theme/Default'

const StyledImg = styled('img')(() => ({
  width: '40vw',
  maxWidth: '180px',
  margin: '0.5rem auto',
  marginBottom: '1rem'
}))

const ErrorLayout = ({ children }) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: '0',
        left: '0',
        overflow: 'hidden',
        width: '100vw',
        height: '100vh',
        zIndex: '2000',
        backgroundColor: theme.palette.leitura.main
      }}
    >
      <Box
        sx={{
          maxWidth: { xs: '360px', md: '480px', xl: '540px' },
          margin: 'auto',
          display: 'flex',
          flexDirection: 'column',

          marginTop: { xs: '30%', md: '12%', xl: '14%' },
          background: 'rgba(255,255,255,0.7)',
          padding: '1rem 1.75rem',
          borderRadius: '0.3rem'
        }}
      >
        <StyledImg src={Logo} />
        {children}
      </Box>
    </div>
  )
}

ErrorLayout.propTypes = {
  children: any
}

export default ErrorLayout
